import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from '../components/Breadcrumb'
import PaymentUrlLayer from '../components/PaymentUrlLayer'

function PaymentUrlPage() {
  return (
     <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* BreadCrumb */}
                <Breadcrumb title='Phone number'/>

               {/* Payment Url layer */}
               <PaymentUrlLayer/>

            </MasterLayout>
        </>
  )
}

export default PaymentUrlPage